import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {ArticlesService} from '../services/articles.service';
import { PageTitleComponent } from '../shared/page-title/page-title.component';
import { HomeFeedComponent } from '../blog/home-feed/home-feed.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [PageTitleComponent, HomeFeedComponent]
})
export class HomeComponent {
  private articleService = inject(ArticlesService);
  private destroyRef = inject(DestroyRef);

  type = 'home';
  titleContent;

  constructor() {
    this.getTitle();
  }

  getTitle() {
    this.articleService.getTitle().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      const filteredTitle = data.filter((title) => title.attributes.page === this.type);
      this.titleContent = filteredTitle[0];
    });
  }
}
